import Cookies from 'universal-cookie'
import { cookieSettings } from 'gatsby-theme-kn/src/utils/partner_portal_spa'

const cookies = new Cookies()
const downloadListLimit = 180
const downloadListCookieName = 'download_list'

// @info: Der Parameter "setter" ist die useState Methode, damit ein ReRendering stattfindet
export function clickUploadToDownloadList(uploadId, setter) {
  let content = downloadList()
  let index = content.indexOf(uploadId)
  // Falls der Upload noch nicht in der Liste ist
  if (index < 0) {
    addUploadToDownloadList(uploadId, content, setter)
  } else {
    removeUploadFromDownloadList(uploadId, content, index, setter)
  }
}

export function clearDownloadList(setter) {
  cookies.remove(downloadListCookieName, cookieSettings())
  setter(downloadList())
}

export function downloadList() {
  let content = cookies.get(downloadListCookieName)
  return content || []
}

export function downloadListCount() {
  return downloadList().length
}

export function isUploadInList(uploadId) {
  if (downloadList().indexOf(uploadId) >= 0) {
    return true
  } else {
    return false
  }
}

function addUploadToDownloadList(uploadId, content, setter) {
  if (content.length < downloadListLimit) {
    content.push(uploadId)
    cookies.set(downloadListCookieName, content, cookieSettings())
    setter(downloadList())
  }
}
function removeUploadFromDownloadList(uploadId, content, index, setter) {
  content.splice(index, 1)
  cookies.set(downloadListCookieName, content, cookieSettings())
  setter(downloadList())
}
